import React from "react";

export default function CustomButton({ ...rest }) {
  return <button {...rest}>{rest.value}</button>;
}
